export class ProductTreatmentCard extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els?.button?.exists) {
      this.listeners.add(
        this.els.button.element,
        'click',
        this.onButtonClick.bind(this),
      )
    }
  }

  onButtonClick (e) {
    const buttonEl = e.target.closest(this.els.button.selector)

    if (!buttonEl) return

    this.setAttribute(
      'data-expanded',
      this.getAttribute('data-expanded') === 'true' ? 'false' : 'true',
    )
  }
}

if (!customElements.get('product-treatment-card')) {
  customElements.define('product-treatment-card', ProductTreatmentCard)
}
